export const getBranch = () => {
  let branchData = localStorage.getItem('branch');

  if (branchData) {
    branchData = JSON.parse(branchData);
  }
  return {
    branchId: branchData?.id,
    branchCode: branchData?.code,
    branchName: branchData?.name,
    companyAddress: {
      ...branchData,
    },
  };
};

const parseLocalStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return null;
  }
};

/**
 * เบอร์โทรที่แสดงบนหัวเอกสาร (PDF + preview) ต้องเป็นเบอร์ของ "สาขา" ที่เลือกอยู่
 * (Branch.phoneNumber) เท่านั้น ไม่ใช่เบอร์กลางของบริษัทที่เก็บใน x-tenant-id
 *
 * ถ้าสาขายังไม่ได้กรอกเบอร์ -> คืน '' ให้หัวเอกสารว่างไว้ (ห้าม fallback เป็นเบอร์บริษัท)
 * ฝั่ง API มี middleware override ให้อีกชั้นก่อน gen PDF — resolveBranchTelephone
 */
export const getDocumentTelephone = () => {
  return parseLocalStorage('branch')?.phoneNumber?.trim() || '';
};

export const getCompany = () => {
  const companyInfo = JSON.parse(localStorage.getItem('x-tenant-id'));

  return {
    taxIdent: companyInfo?.companyTaxIdent,
    businessType: companyInfo?.businessType,
    companyName: companyInfo?.companyName,
    logoCompany: companyInfo?.logoCompany,
    email: companyInfo?.email,
    telephone: getDocumentTelephone(),
    eStamp: companyInfo?.eStamp,
    vatRegister: companyInfo?.vatRegister,
  };
};

export const getUser = () => {
  const userData = JSON.parse(localStorage.getItem('user'));
  return {
    userId: userData?.id,
    userFirstName: userData?.firstName,
    userLastName: userData?.lastName,
    userSignature: userData?.signature,
  };
};

export const getDocFormat = () => {
  const docFormatData = JSON.parse(localStorage.getItem('docFormat'));

  return {
    dateFormats: docFormatData?.dateFormats,
    yearType: docFormatData?.yearType,
    theme: docFormatData?.theme,
    isApprovalDate: docFormatData?.isApprovalDate,
    settingTypeNo: docFormatData?.settingTypeNo,
  };
};

export const getLocal = () => {
  return localStorage.getItem('i18n_locale');
};

// --- Pending import job (สำหรับ resume polling หลัง navigate/refresh) ---
// เก็บแยกตาม docType (RC/QT/IV) กันชนกัน; ปกติมี job เดียวต่อชนิดในเวลาเดียว
const PENDING_IMPORT_KEY = (docType) => `pendingImportJob_${docType}`;

export const setPendingImportJob = (docType, job) => {
  localStorage.setItem(PENDING_IMPORT_KEY(docType), JSON.stringify(job));
};

export const getPendingImportJob = (docType) => {
  const raw = localStorage.getItem(PENDING_IMPORT_KEY(docType));
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

export const clearPendingImportJob = (docType) => {
  localStorage.removeItem(PENDING_IMPORT_KEY(docType));
};
